import { inject as service } from '@ember/service';
import DomainSelect from 'volta/components/domain-select';
import { PartTypeResourceName } from 'volta/models/part-type';
import JsonApiInfinityModel, { decorateApiQuery } from 'volta/models/jsonapi-infinity-model';
import { lkFilter } from 'volta/utils/filters-utils';

export default DomainSelect.extend({
  idKey: 'id',
  infiniteScroll: true,

  searchPromise(payload) {
    return this.infinity.model(
      PartTypeResourceName.singular,
      decorateApiQuery(payload),
      JsonApiInfinityModel
    );
  },

  payloadFromTerm(term) {
    const query = { sort: 'code' };

    if (term && term !== '') {
      query.filter = {
        q: lkFilter(term)
      };
    }
    return decorateApiQuery(query);
  }
});
